import * as React from 'react'
// views
import { PermissionOptionTitle, PermissionOptionWrapper } from './view'

// types
interface Props {
  description: string
  handleSetPermission: () => void
  icon: () => React.ReactNode
  isActive: boolean
  title: string
}

export const PermissionOption: React.FC<Props & any> = ({
  description,
  handleSetPermission,
  icon,
  isActive,
  title
}) => {
  return (
    <PermissionOptionWrapper
      isActive={isActive}
      onClick={handleSetPermission}
      data-testid={`visibility-option-${title.toLowerCase()}`}>
      <PermissionOptionTitle>
        {icon(isActive)}
        <p>{title}</p>
      </PermissionOptionTitle>
      <p>{description}</p>
    </PermissionOptionWrapper>
  )
}

export default PermissionOption
